// import external dependencies
import $ from 'jquery';
import jQuery from 'jquery';
import 'bootstrap';
//window.Popper = require('popper.js')
import 'slick-carousel';

// Import FontAwesome
import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { faEnvelope, faFax, faPhone, faBars, faUser, faSpinner, faSearch, faTimes, faArrowRight, faAngleRight, faPlusSquare, faCheck, faTruck } from '@fortawesome/free-solid-svg-icons'
import { faLinkedinIn, faTwitter, faFacebookF, faYoutube, faInstagram, faViadeo, faFacebookSquare, faLinkedin } from '@fortawesome/free-brands-svg-icons'
library.add(faTimes, faSearch, faEnvelope, faFax, faPhone, faLinkedinIn, faTwitter, faFacebookF, faYoutube, faInstagram, faViadeo, faBars, faUser, faSpinner, faFacebookSquare, faLinkedin, faArrowRight, faAngleRight, faPlusSquare, faCheck, faTruck);
dom.watch()

// import local dependencies

// MODERNIZR for detect webp images browser support
// https://modernizr.com/download?webp-setclasses&q=webp
Modernizr.on('webp', function (result) {
  if (result) {
    // supported
  } else {
    // not-supported
  }
});

//LAZY LOAD !!
document.addEventListener("DOMContentLoaded", function() {
  var lazyloadImages = document.querySelectorAll("img.lazy");
  var lazyloadThrottleTimeout;

  function lazyload () {
    if(lazyloadThrottleTimeout) {
      clearTimeout(lazyloadThrottleTimeout);
    }

    lazyloadThrottleTimeout = setTimeout(function() {
        var scrollTop = window.pageYOffset;
        $.each(lazyloadImages, function(index, img) {
            if(img.offsetTop < (window.innerHeight + scrollTop)) {
              img.src = img.dataset.src;
              img.classList.remove('lazy');
            }
        });
        if(lazyloadImages.length == 0) {
          document.removeEventListener("scroll", lazyload);
          window.removeEventListener("resize", lazyload);
          window.removeEventListener("orientationChange", lazyload);
        }
    }, 20);
  }

  document.addEventListener("scroll", lazyload);
  window.addEventListener("resize", lazyload);
  window.addEventListener("orientationChange", lazyload);
  lazyload();
});



jQuery(document).ready(function() {


  /********* STICKY MENU **********/
  var stickyNavTop = $('#wrapper-navbar').offset().top;

  var stickyNav = function(){
    var scrollTop = $(window).scrollTop();

    if (scrollTop > stickyNavTop) {
        $('#wrapper-navbar').addClass('sticky');
    } else {
        $('#wrapper-navbar').removeClass('sticky');
    }
  };

  stickyNav();

  $(window).scroll(function() {
      stickyNav();
  });




  var initHome = function(){

    if($('.btn-search').length > 0){
      $('.btn-search').click(function(e){
        e.preventDefault();
        $(this).toggleClass('search');
        $('header div.logo').toggleClass('search');
        if($('header div.logo').hasClass('search')){
          $('header .search-form .form-control').focus();
        }
      });
    }

    if($('.home-slider').length > 0){
      $('.home-slider .home-carousel').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots:false,
          fade: true,
          autoplay: true,
          autoplaySpeed: 5000,
          infinite: true,
          lazyLoad: 'ondemand',
          rows: 0
      });
    }

    if($('.brands').length > 0){
      $('.brands .categories .list').slick({
          slidesToShow: 5,
          arrows: false,
          dots:false,
          autoplay: true,
          infinite: true,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 3
              }
            }
          ]
      });
    }

    if($('.custom').length > 0){
      $('.custom .list').slick({
          arrows: true,
          dots:false,
          autoplay: true,
          infinite: false,
      });
    }

    if($('.customers').length > 0){
      $('.customers .list').slick({
          centerMode: true,
          centerPadding: '60px',
          slidesToShow: 5,
          arrows: false,
          dots:false,
          autoplay: true,
          infinite: true,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 3
              }
            }
          ]
      });
    }

    if($('.jobs').length > 0){
      $('.jobs .list').slick({
          slidesToShow: 6,
          arrows: false,
          dots:false,
          autoplay: true,
          infinite: false,
          responsive: [
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 3,
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                dots:true
              }
            }
          ]
      });
    }

    if($('.services').length > 0){
      $('.services .list').slick({
          slidesToShow: 6,
          arrows: false,
          dots:false,
          autoplay: false,
          infinite: false,
          responsive: [
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots:true
              }
            }
          ]
      });
    }

    if($('.links').length > 0){
      $('.links .list').slick({
          slidesToShow: 3,
          arrows: false,
          dots:false,
          autoplay: false,
          infinite: false,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots:true
              }
            }
          ]
      });
    }

  }

  var initTextSeo = function(){
    if($('.text-seo').length > 0){
      //pour les textes trop long, le texte est en partie caché, un bouton permet d'afficher le tout
      $('.open-read-more').click(function(e){
        e.preventDefault();
        $('.text-seo').toggleClass('open');
      });
    }
  }

  var initNewsletter = function(){
    //formulaire de newsletter
    if($('#newsletter-form').length > 0){

      //on enregistre l'inscription à la newsletter
      $('#newsletter-form .btn-submit').click(function(e) {
          e.preventDefault();
          var button = $(this);
          var form = $('#newsletter-form .newsletter-form');
          $('.block-newsletter .error').html('');
          $('.block-newsletter .error').hide();

          button.hide();
          $('.block-newsletter .loader').removeClass('hide');
          $.ajax({
              method: "POST",
              url: form.attr('action'),
              data: form.serialize(),
              success: function( response ) {
                $('.block-newsletter .loader').addClass('hide');
                button.show();
                if(response == 'ok'){
                    $('.block-newsletter .error').html(response);
                }
                else{
                    $('.block-newsletter .error').html(response);
                }
                $('.block-newsletter .error').fadeIn();
              }
          });
      });
    }

    if($('#newsletter-form-out').length > 0){

      //on enregistre la désinscription à la newsletter
      $('#newsletter-form-out .btn-submit').click(function(e) {
          e.preventDefault();
          var button = $(this);
          var form = $('#newsletter-form-out  .newsletter-form');
          $('.block-newsletter-out .error').html('');
          $('.block-newsletter-out .error').hide();

          button.hide();
          $('.block-newsletter-out .loader').removeClass('hide');
          $.ajax({
              method: "POST",
              url: form.attr('action'),
              data: form.serialize(),
              success: function( response ) {
                $('.block-newsletter-out .loader').addClass('hide');
                button.show();
                if(response == 'ok'){
                    $('.block-newsletter-out .error').html(response);
                }
                else{
                    $('.block-newsletter-out .error').html(response);
                }
                $('.block-newsletter-out .error').fadeIn();
              }
          });
      });
    }
  }


  var initSingleProduct = function(){
    //fiche produit
    if($('.variations_form').length > 0){

      var select_variations = {};

      function getVariations(){
        $('.variations_form .variations select.woo-variation-raw-select').each(function(){
          var name = $(this).attr('name');
          var value = $(this).val();
          select_variations[name] = value;
        });
        //console.log(select_variations);
      }
      getVariations();



      /*var form = $('.variations_form');
      $('ul.variable-items-wrapper').each(function (i, el) {

          var select = $(this).siblings('select.woo-variation-raw-select');
          var li = $(this).find('li');
          var reselect_clear = $(this).hasClass('reselect-clear');
          var is_mobile = $('body').hasClass('woo-variation-swatches-on-mobile');

          $(this).parent().addClass('woo-variation-items-wrapper');

          $(this).on('touchstart click', 'li a', function (e) {

              e.preventDefault();
              e.stopPropagation();
              var value = $(this).data('value');
              console.log(select.val());
              select.val(value).trigger('change');
              console.log(select.val());
              select.trigger('click');
              select.trigger('focusin');
              if (is_mobile) {
                  select.trigger('touchstart');
              }

              $(this).trigger('focus'); // Mobile tooltip

          });

        });*/

      //les options/attributs du produits ont un affichage personnalisé.
      //Quand on lcique dessus on change la valeur du select par défaut.

      $('.variations_form .variations ul li a').on('click', function(e) {
        e.preventDefault();
        var value = $(this).data('value');
        var title = $(this).attr('title');
        var attribut = $(this).parent().parent().data('attribute_name');
        var elem = $('select#'+attribut);

        elem.val( value ).trigger("change");
        elem.val( value ).trigger("woocommerce_variation_has_changed");

        //on emt à jour la valeur dans le formulaire pour le bouton demander un devis également
        $('form.devis input.attribute_'+attribut+'').val(value);


        var form = $('.variations_form');

    		/*form.find( 'input[name="variation_id"], input.variation_id' ).val( '' ).trigger( 'change' );
    		form.find( '.wc-no-matching-variations' ).remove();
  			form.trigger( 'woocommerce_variation_select_change' );
  			form.trigger( 'check_variations' );// Custom event for when variation selection has been changed
    		form.trigger( 'woocommerce_variation_has_changed' );*/

        var variations = form.data('product_variations');
        var is_ajax_variation = false;
        if(variations == false) is_ajax_variation = true;
        //console.log(variations)
        //var test = {attribute_pa_couleur:'orange', attribute_pa_taille:'xl'};
        //var test2 = JSON.stringify(test);
        getVariations();
        var select_variations_string = JSON.stringify(select_variations);

        $.each(variations, function() {
           var attributes = this.attributes;

           var all_ok = true;
           $.each(attributes, function() {
             if(this == '' || typeof this === "undefined"){
               all_ok = false;
             }
           });
           //console.log(all_ok);
           if(all_ok){
             var myJSON = JSON.stringify(attributes);
             //console.log(myJSON);
             if(myJSON == select_variations_string){
               //console.log(this.display_price);
               if(this.variation_id){
                 if(this.price_html && $('.woocommerce-variation-add-to-cart .variation_price').length>0){
                   var suf = $('.woocommerce-variation-add-to-cart .variation_price').data('suf');
                   $('.woocommerce-variation-add-to-cart .variation_price').html(this.price_html);
                   $('.woocommerce-variation-add-to-cart .variation_price').fadeIn();
                 }
                 $('.woocommerce-variation-add-to-cart input.variation_id').val(this.variation_id);
                 $('form.devis input.variation_id').val(this.variation_id);

                 $('.woocommerce-variation-add-to-cart').removeClass('woocommerce-variation-add-to-cart-disabled');
                 $('.woocommerce-variation-add-to-cart').addClass('woocommerce-variation-add-to-cart-enabled');
                 $('.woocommerce-variation-add-to-cart .addtocart button.single_add_to_cart_button').removeClass('disabled');
                 return false;
               }
               //console.log('here');
               //console.log(this.variation_id);
            }
          }
        });

        $(this).parent().parent().find('a').removeClass('selected');
        $(this).addClass('selected');
        var attribut = $(this).parent().parent().parent().parent().find('.defaultvalue').html('- '+title);
      });


      $('select').on('woocommerce_variation_has_changed', function(){
          //https://github.com/woocommerce/woocommerce/blob/master/assets/js/frontend/add-to-cart-variation.js
          //AJAX
       });



      if($('.variations_form .variations select').length > 0){
        $('.variations_form .variations select option').each(function(){
          if($(this).attr('selected') == 'selected'){
            var value = $(this).val();
            $(this).parent().parent().find('ul li a.'+value).trigger('click');
          }
        });
      }

      $( '.variations select' ).change();







      //on sélectionne l'image de la gallery qui correspond à la couleur sélectionnée
      if($('.variations_form .variations ul.attribute_pa_couleur li a.selected').length > 0){
        var img = $('.variations_form .variations ul.attribute_pa_couleur li a.selected').find('img').attr('src');
        if(img) $(".woocommerce-product-gallery img[src$='"+img+"']").trigger('click');
        $('.variations_form .variations ul.attribute_pa_couleur li a').click(function() {
          var img = $(this).find('img').attr('src');
          if(img) $(".woocommerce-product-gallery img[src$='"+img+"']").trigger('click');
        });
      }
    }

    $('#contactModal').on('shown.bs.modal', function () {
      //SKU produit 4
      $('#input_4_4').val($('#contactModal .modal-body').data('psku'));
      //intitulé produit 7
      $('#input_4_7').val($('#contactModal .modal-body').data('ptitle'));
      //URL page 8
      $('#input_4_8').val($('#contactModal .modal-body').data('url'));
      //ID produit 6
      $('#input_4_6').val($('#contactModal .modal-body').data('pid'));
    });


    (function ($) {

        $(document).on('click', '.single_add_to_cart_button', function (e) {
            e.preventDefault();

            var $thisbutton = $(this),
                    $form = $thisbutton.closest('form.cart'),
                    id = $thisbutton.val(),
                    product_qty = $form.find('input[name=quantity]').val() || 1,
                    product_id = $form.find('input[name=product_id]').val() || id,
                    variation_id = $form.find('input[name=variation_id]').val() || 0;

            var data = {
                action: 'woocommerce_ajax_add_to_cart',
                product_id: product_id,
                product_sku: '',
                quantity: product_qty,
                variation_id: variation_id,
            };

            $(document.body).trigger('adding_to_cart', [$thisbutton, data]);

            if($('.woocommerce-variation-add-to-cart .addtocart button.single_add_to_cart_button').hasClass('disabled') == false){
              $.ajax({
                  type: 'post',
                  url: wc_add_to_cart_params.ajax_url,
                  data: data,
                  beforeSend: function (response) {
                      $thisbutton.removeClass('added').addClass('loading');
                  },
                  complete: function (response) {
                      $thisbutton.addClass('added').removeClass('loading');
                  },
                  success: function (response) {
                    //console.log(response);

                      if (response.error && response.product_url) {
                          window.location = response.product_url;
                          return;
                      } else {
                          $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);
                      }

                      //console.log('open popup');
                      $('#addToCartModal').modal('show');
                      updateMiniCart();

                  },
              });
            }


            return false;
        });
        $(document).on('click', '#addToCartModal a.close', function (e) {
          e.preventDefault();
          $('#addToCartModal button.close').trigger('click');
        });
    })(jQuery);


  }

  var updateMiniCart = function(){
    $.ajax({
        type: 'post',
        url: $('.customize-shopping-cart').data('url'),
        success: function (response) {
            if (response) {
                $('.customize-shopping-cart').html(response);
            }

        },
    });

  }

  $(document).on('click', '.mini_cart_item a.remove', function (e){
    var qtt = $(this).parent().find('.quantity').text();
    var parts = qtt.split("×");
    if(parts[0]){
      var counter = $('.customize-shopping-cart .counter').text();
      counter = counter - parts[0];
      $('.customize-shopping-cart .counter').text(counter);
    }
  });
  $(document).on('click', '.woocommerce-cart .product-remove a', function (e){
    var qtt = $(this).parent().parent().find('.qty').val();
    if(qtt){
      var counter = $('.customize-shopping-cart .counter').text();
      counter = counter - qtt;
      $('.customize-shopping-cart .counter').text(counter);
    }
  });

  var qtt = $('.single-product .quantity .qty').val();
  if(qtt){
    $('form.devis input[name=product_qtt]').val(qtt);
  }
  $(document).on('change', '.single-product .quantity .qty', function (e){
    var qtt = $(this).val();
    //console.log(qtt);
    if(qtt){
      $('form.devis input[name=product_qtt]').val(qtt);
    }
  });


  var initContactDevis = function(){
    //page formulaire de devis contact
    if($('.post-22 form').length > 0){
      var gform = $('post-22 form');
      /*gform.addAction( 'gform_input_change', function( elem, formId, fieldId ) {
        console.log('here');
      }, 10, 3 );*/

      //on sauvegarde les données saisies dans le formulaire de devis à la volée pour le pré-remplir au prochain affichage
      $('.ginput_container input, .ginput_container textarea').on("change paste keyup", function() {
         var field_value = $(this).val();
         var field_name = $(this).attr('name');
         var url = $('.entry-content').data('ajx');
         if(url && field_name && field_value){
           if(field_name == 'input_12[]'){
             var label = $(this).attr('aria-label');
             var ref = $(this).parent().parent().find('.gfield_list_12_cell2 input').val();
             $.post(url, {field_name:label, field_value:field_value, ref:ref});
           }
           else{
             $.post(url, {field_name:field_name, field_value:field_value});
           }
         }
      });
      //pour supprimer une ligne de produit dans le formulaire de devis
      $('.delete_list_item').click(function(e){
        var parent = $(this).parent().parent();
        var values = [];
        var url = $('.entry-content').data('ajx');
        parent.find('input').each(function( index ) {
          //console.log($(this).val());
          values.push($(this).val());
        });
        parent.find('select').each(function( index ) {
          //console.log($(this).val());
          values.push($(this).val());
        });
        $.post(url, {delete:values});
      });

      if($('.post-22 #devisModalButton').length > 0){
        $('#devisModalButton').trigger('click');
      }
    }
  }


  var initCategory = function(){


    function reloadProductsByFilters(){
      var url = $('.filters').data('url');
      var delimiter = "?";
      if(url.includes('?')) {
          delimiter = "&";
      }
      //var url = document.location.href;

      if(brandId != false && brandId != 0){
        if(url.includes('?')) {
            delimiter = "&";
        }
        url = url+delimiter+"marque="+brandId;
      }

      if(normeId != false && normeId != 0){
        if(url.includes('?')) {
            delimiter = "&";
        }
        url = url+delimiter+"norme="+normeId;
      }

      if(jobId != false && jobId != 0){
        if(url.includes('?')) {
            delimiter = "&";
        }
        url = url+delimiter+"metier="+jobId;
      }

      if(colorId != false && colorId != 0){
        if(url.includes('?')) {
            delimiter = "&";
        }
        url = url+delimiter+"couleur="+colorId;
      }

      if(tailleId != false && tailleId != 0){
        if(url.includes('?')) {
            delimiter = "&";
        }
        url = url+delimiter+"taille="+tailleId;
      }

      if(prices != false && prices != 0){
        if(url.includes('?')) {
            delimiter = "&";
        }
        url = url+delimiter+"prices="+prices;
      }

      document.location = url;
    }

    if($('#price-range-slider').length > 0){


      //slider buttons for filter price
      var prices = 0;
      var Slider = require("bootstrap-slider");
      var slider = new Slider('#price-range-slider', {
        tooltip_split:true,
      	formatter: function(value) {
      		return value+'€';
      	}
      }).on('change', function(event){
        //console.log(slider.getValue());
        prices = slider.getValue();
        reloadProductsByFilters();
      });

    }

    //filtres produits
    //on ne boucle pas sur un tableau mais on duplique le code pour pouvoir faire évoluer un filtre si besoin
    //au changement d'un filtre on passe la valeur (slug) en paramètre get, on remet les autres filtres également en GET et on recharge la page
    if($('.filters').length > 0){

      var brandId = 0;
      if($('.dropdown.brands a.selected').length > 0) brandId = $('.dropdown.brands a.selected').data('id');
      var normeId = 0;
      if($('.dropdown.normes a.selected').length > 0) normeId = $('.dropdown.normes a.selected').data('id');
      var jobId = 0;
      if($('.dropdown.jobs a.selected').length > 0) jobId = $('.dropdown.jobs a.selected').data('id');
      var colorId = 0;
      if($('.dropdown.colors a.selected').length > 0) colorId = $('.dropdown.colors a.selected').data('id');
      var tailleId = 0;
      if($('.dropdown.tailles a.selected').length > 0) tailleId = $('.dropdown.tailles a.selected').data('id');

      if($('.filters').hasClass('scroll')){
        $('html,body').animate({ scrollTop: $('.filters').offset().top }, 'fast');
      }

      $('.dropdown').each(function (key, dropdown) {
          var $dropdown = $(dropdown);
          var $selected = $dropdown.find('.dropdown-menu a.selected');
          if($selected.text()) $dropdown.find('button').text($selected.text());
      });

      $('.dropdown.brands a').on('click', function(e){
          e.preventDefault();
          brandId = $(this).data('id');
          reloadProductsByFilters();
      });

      $('.dropdown.normes a').on('click', function(e){
          e.preventDefault();
          normeId = $(this).data('id');
          reloadProductsByFilters();
      });

      $('.dropdown.jobs a').on('click', function(e){
          e.preventDefault();
          jobId = $(this).data('id');
          reloadProductsByFilters();
      });

      $('.dropdown.colors a').on('click', function(e){
          e.preventDefault();
          colorId = $(this).data('id');
          reloadProductsByFilters();
      });

      $('.dropdown.tailles a').on('click', function(e){
          e.preventDefault();
          tailleId = $(this).data('id');
          reloadProductsByFilters();
      });
    }
  }


  var initMenu = function(){


    /***
    * MOBILE
    * */
    if($('#main-menu-mobile .lvl1').length > 0){
      $('#main-menu-mobile .lvl1 a.alvl1').click(function(e){
        e.preventDefault();
        if($(this).parent().find('.submenu2').length > 0){
          if($(this).hasClass('open')){
            $('.submenu2').hide();
            $('#main-menu-mobile .lvl1 a.alvl1').removeClass('open');
          }
          else{
            $('.submenu2').hide();
            $('#main-menu-mobile .lvl1 a.alvl1').removeClass('open');
            $(this).parent().find('.submenu2').show();
            $(this).addClass('open');
          }
        }
        else{
          window.location.href = $(this).attr('href');
        }
      });
    }

    $('#main-menu-mobile').on('click', '.dropdown-menu.show', function (e) {
      e.stopPropagation();
    });

    $('#main-menu-mobile').on('click', '.close', function (e) {
      $(this).parent().parent().parent().find('.dropdown-toggle').trigger('click');
    });

    /*if($('#main-menu-mobile .menu-item').length > 0){
      $('#main-menu-mobile .menu-item.show a.dropdown-toggle').click(function(e){
        e.preventDefault();
        console.log('stoopp');
      });
    }*/

    /***
    * DESCTOP
    * */
    if($('#main-menu .lvl1').length > 0){
      $('#main-menu .lvl1 a.alvl1').hover(
        function(){
          $('.submenu2').hide();
          $('#main-menu .lvl1 a.alvl1').removeClass('open');
          $(this).parent().find('.submenu2').show();
          $(this).addClass('open');
        },
        function(){
          //$(this).parent().find('.submenu2').hide();
        }
      );
    }


    /*if($('#main-menu .menu-item').length > 0){
      $('#main-menu .menu-item').hover(
        function(){
          $(this).find('.submenu2').hide();
          $(this).find('a.alvl1').removeClass('open');
          $(this).find('.lvl1.first .submenu2').show();
          $(this).find('.lvl1.first a.alvl1').addClass('open');

          $(this).toggleClass("open");
          $(this).children('.dropdown-menu').toggleClass("show");


        },
        function(){
          $(this).toggleClass("open");
          $(this).children('.dropdown-menu').toggleClass("show");
        }
      );
      $('#main-menu .menu-item').click(function(e){
        window.location.href = $(this).children('.dropdown-toggle').attr('href');
      });
    }*/

    if($('#main-menu .dropdown-toggle').length > 0){
      $('#main-menu .dropdown-toggle').click(function(){
        $(this).parent().find('.submenu2').hide();
        $(this).parent().find('a.alvl1').removeClass('open');
        $(this).parent().find('.lvl1.first .submenu2').show();
        $(this).parent().find('.lvl1.first a.alvl1').addClass('open');
      });
    }

  }


  var initCart = function(){
    if($('.woocommerce-cart .custom .btn-form-custom').length > 0){
      $('.woocommerce-cart .custom .btn-form-custom').click(function(e){
        e.preventDefault();
        $(this).hide();
        $('.woocommerce-cart .cart-collaterals').hide();
        $('.woocommerce-cart .custom .form').show();
      });
    }
    if($('.woocommerce-cart .custom .btn-nocustom').length > 0){
      $('.woocommerce-cart .custom .btn-nocustom').click(function(e){
        e.preventDefault();
        $('.woocommerce-cart .custom .form').hide();
        $('.woocommerce-cart .custom .btn').show();
        $('.woocommerce-cart .cart-collaterals').show();
      });
    }

    if($('#customModal').length > 0){
      var myModal = $('#customModal');
      $('.woocommerce-cart .wc-proceed-to-checkout .checkout-button').on('click', function(e){
        e.preventDefault();
        myModal.modal('show');
        var url = $(this).attr('href');
        $('#customModal .btn-ok').click(function(e){
          e.preventDefault();
          myModal.modal('hide');
          location.href = url;
        });
        $('#customModal .btn-no').click(function(e){
          e.preventDefault();
          myModal.modal('hide');
          $('.woocommerce-cart .custom .btn-form-custom').hide();
          $('.woocommerce-cart .cart-collaterals').hide();
          $('.woocommerce-cart .custom .form').show();
        });
      });

    }

    if($('.woocommerce-cart .product-remove').length > 0){
      $('.woocommerce-cart .product-remove a').click(function(e){
        e.preventDefault();
        document.location.href = $(this).attr('href');
      })
    }
  }




  var initMain = function(){
      initHome();
      initTextSeo();
      initNewsletter();
      initSingleProduct();
      initContactDevis();
      initCategory();
      initMenu();
      initCart();
  }

  initMain();

});

$(window).on('load',function(){
  if($('#infoModal').length > 0){
    var infoModalStorage = localStorage.getItem('infoModal');
    if(infoModalStorage != 'true') $('#infoModal').modal('show');
    $('#infoModal').on('hidden.bs.modal', function (e) {
      localStorage.setItem('infoModal', 'true');
    });
  }
});
